<template>
    <div>
        <a v-if="customer" class="text-bold title-link" :href="customer.link">{{customer.fullname}}</a>
        <p v-else>{{orderClientName}}</p>
    </div>
</template>
<script>
import Vue from 'vue';

export default {
    data() {
        return {

        }
    },

    components: {

    },

    props: ['initialValue', 'css', 'data'],

    computed: {
        customer() {
            const id = _.get(this.data, 'customer.id');
            const registered = _.get(this.data, 'customer.registered');
            const firstname = _.get(this.data, 'customer.firstname', '');
            const lastname = _.get(this.data, 'customer.lastname', '');

            if (!id || !registered) return;

            return {
                id,
                link: `#/customer/${id}`,
                fullname: [firstname, lastname].join(' '),
            }
        },
        orderClientName() {
            const firstname = _.get(this.data, 'firstname', '');
            const lastname = _.get(this.data, 'lastname', '');

            return [firstname, lastname].join(' ');
        }
    },

    mounted() {

    },

    methods: {

    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/table-elements/OrderCustomerComponent.vue